import React from 'react';
import {
    IconButton,
    colors,
} from '@mui/material';
import {
    ArrowRightCircle as ArrowRight,
    ArrowLeftCircle as ArrowLeft,
} from 'react-feather';
import { useSelector } from 'react-redux';
import "./Layout.css";
import NavItem from './NavBar/NavItem';
import { getApprovedGeneralNavItems, getMainNavItems } from '../permissions/landingRoute';
import { usePermissionState } from '../stores/permissionStore';

const MobileMenu = ({ setMobileNavOpen, isMobileNavOpen }) => {
    const auth = useSelector((state) => state.UserReducer.isAuthenticated);
    const permissionState = usePermissionState();
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies);
    const mainNavItems = getMainNavItems(permissionState, userCompany);
    const generalNavItems = getApprovedGeneralNavItems(permissionState, userCompany);

    return (
        <div
            elevation={0}
            style={{ backgroundColor: colors.grey[800] }}
            className="MoblieMenu"
        >
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className="MobileMenuDisplay">
                    {auth &&
                        <IconButton sx={{ color: "white" }} onClick={() => setMobileNavOpen(!isMobileNavOpen)} size="large" style={{ width: "30%" }}>
                            <div style={{ paddingRight: "5px" }}>Menu</div>
                            {isMobileNavOpen ?
                                <ArrowRight />
                                :
                                <ArrowLeft />
                            }
                        </IconButton>
                    }
                    <div style={{ width: '70%', borderRadius: "5px" }}>
                        <div className="mobileList" style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto', scrollbarWidth: 'none', width: 'maxContent' }}>
                            <ul className="MobileMenuOptions" style={{ alignItems: "center" }}>
                                {mainNavItems.map((item) => (
                                    <div key={item.title} style={{ backgroundColor: "white", height: '100%', alignContent: 'center' }}>
                                        <NavItem
                                            href={item.href}
                                            title={item.title}
                                            icon={item.icon}
                                        />
                                    </div>
                                ))}
                                {generalNavItems.map((item) => (
                                    <div key={item.title} style={{ backgroundColor: "white", height: '100%', alignContent: 'center' }}>
                                        <NavItem
                                            href={item.href}
                                            title={item.title}
                                            icon={item.icon}
                                        />
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;
